import { Box, Card, Divider, Typography } from '@mui/material';
import { useAuthContext } from '../../../../Context/AuthContext/AuthContext';
import { usePaymentDataQuery } from './api/paymentApi';
import OfflinePaymentCardInformation from './offline/OfflinePaymentCardInformation';
import OfflinePaymentInformation from './offline/OfflinePaymentInformation';
const PaymentInformation = ({
  setPaymentOfflineInformation,
}: {
  setPaymentOfflineInformation: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const { user } = useAuthContext();

  const { data } = usePaymentDataQuery({
    service_type: 'NEW_MEMBERSHIP_FEE',
    related_id: user.user_member_id,
  });
  return Object?.keys(data)?.length === 0 && user.is_applied ? (
    //old member  has no payment information. so dont show it here.
    <></>
  ) : (
    <Card
      sx={{
        marginBottom: '10px',
      }}
    >
      <Box
        sx={{
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant='h3' sx={{ p: 2 }}>
            Payment information
          </Typography>
        </Box>

        <Divider light />
        {data && data?.type ? (
          <OfflinePaymentCardInformation data={data} />
        ) : (
          <OfflinePaymentInformation
            setPaymentOfflineInformation={setPaymentOfflineInformation}
          />
        )}
      </Box>
    </Card>
  );
};

export default PaymentInformation;
